import React from 'react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(13,13,13,0.08)] py-10 px-4 md:px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-5">
        <Link href="/homepage" className="flex items-center gap-2">
          <div className="flex items-center">
            <img
              alt="Logo"
              width={28}
              height={28}
              className="flex-shrink-0"
              src="https://homeify-o47ru61.public.builtwithrocket.new/_next/image?url=%2Fassets%2Fimages%2Fapp_logo.png&w=64&q=85" />
            
          </div>
          <span className="font-sans font-bold text-base text-ink">
            Homeify<span className="font-serif italic font-normal text-ink-muted">Services</span>
          </span>
        </Link>
        <div className="flex items-center gap-6 flex-wrap justify-center">
          <Link href="/homepage#services" className="text-[14px] font-medium text-ink-muted hover:text-ink transition-colors">Services</Link>
          <Link href="/homepage#why" className="text-[14px] font-medium text-ink-muted hover:text-ink transition-colors">Why Us</Link>
          <Link href="/homepage#process" className="text-[14px] font-medium text-ink-muted hover:text-ink transition-colors">Process</Link>
          <Link href="#" className="text-[14px] font-medium text-ink-muted hover:text-ink transition-colors">Privacy</Link>
          <Link href="#" className="text-[14px] font-medium text-ink-muted hover:text-ink transition-colors">Terms</Link>
        </div>
        <p className="text-[13px] text-ink-faint font-medium">&copy; 2026 Homeify Services</p>
      </div>
    </footer>);

}